import { useState, useEffect } from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import headerImg from "../../assets/img/bannerImage.png";
import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Banner = () => {
  
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [ "Graphic Design", "Printing", "Packaging", "Branding", "Publishing" ];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => { clearInterval(ticker) };
  }, [text, delta])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    let logg = index
    console.log(logg)

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <section className="banner" id="service">
      <Container>
        <Row className="aligh-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline">Our Services</span><br />
                <h3>{`- `} <span className="txt-rotate" dataPeriod="1000" data-rotate='[ "Graphic Design", "Printing", "Packaging", "Branding", "Publishing" ]'><span className="wrap">{text}</span></span></h3>
                  <p>If you need a quality print job, you ought to depend on proficient printing specialist co-ops. We help you in finishing the work quickly and in an expert way; as well as ship it to you with a trusted courier service to any where you are in the world!  <br /><br />

                  * Branding & Identity: <br />
                  Brand Identity is how your business presents itself to, and wants to be perceived by its consumers. We help our clients improve their brand identity by creating design that speaks for itself. <br /><br />

                  * Convenience is Guaranteed: <br />
                  We provide instant replies to your messages and promote open communication. We will let you know everything you need to know about your job and how far we have gone. We will also let you know when we are done and when it will be shipped to you. <br /><br />
                  
                  * High Quality is Guaranteed: <br />
                  We use sophisticated and advance printing equipment to do our job; this help in maintaining a quality and consistent print media for your brand. We also have a large workforce that are experience enough to deliver in faster turnaround time. <br /><br />
                  
                  * Flexibility: <br />
                  We can design for you to go and print, you can design and bring to us to print for you, and we can also design and print for you. <br /><br />
                  
                  </p>
                  <button>Get A Free Quote Today! <ArrowRightCircle size={25} /></button>
                  <Nav className='subClass'>
                  <Nav.Link href="/get-quote">Click Here to Get Your Free 30-Mins Strategy Section Now!</Nav.Link>
                  </Nav>
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
